<template>
  <div>
    <LittleBanner />
    <div class="ques-content">
      <div class="flex-container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="考务问答" name="all"></el-tab-pane>
          <el-tab-pane label="我的问答" name="my"></el-tab-pane>
          <el-tab-pane label="立即提问" name="submit"></el-tab-pane>
        </el-tabs>
        <div class="search-content">
          <el-input v-model="form.title" size="small" placeholder="请输入搜索关键词" style="width: 300px" @keyup.enter.native="searchData"></el-input>
          <el-button type="primary" size="small" style="margin-left: 10px;" @click="searchData">查询</el-button>
        </div>
      </div>
      <template v-if="total === 0">
        <p class="empty-text">暂时没有数据~</p>
      </template>
      <template v-else>
        <div class="list-content">
          <ul>
            <li v-for="(obj, index) in dataArr" :key="index" class="data-row">
              <div class="title-content">
                <!-- <span class="disc-tag">·</span> -->
                <span class="row-title" @click="toQuesDetail(obj.id)">{{ obj.title }}</span>
                <template v-if="activeName === 'my'">
                  <el-tag v-if="obj.checkStatus" type="success" size="small" class="status-tag">已回复</el-tag>
                  <el-tag v-else type="danger" size="small" class="status-tag">未回复</el-tag>
                </template>
              </div>
              <span class="row-date">{{ obj.createTime }}</span>
            </li>
          </ul>
        </div>
        <div class="page-content">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="form.page"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { myListData, openListData } from '@/api/ques'
import LittleBanner from '../layout/components/LittleBanner'
export default {
  name: 'List',
  data() {
    return {
      activeName: 'all',
      form: {
        title: '',
        page: 1,
        limit: 10
      },
      dataArr: [],
      total: 0
    }
  },
  components: {
    LittleBanner
  },
  mounted() {
    this.getListData()
  },
  methods: {
    searchData() {
      this.form.page = 1
      this.getListData()
    },
    getListData() {
      if (this.activeName === 'my') {
        this.getUserList()
      } else if (this.activeName === 'all') {
        this.getOpenList()
      }
    },
    getUserList() {
      this.dataArr = []
      this.total = 0
      myListData(this.form)
        .then(res => {
          if (res.code === 200) {
            this.dataArr = res.data.list
            this.total = res.data.total
          }
        })
    },
    getOpenList() {
      this.dataArr = []
      this.total = 0
      openListData(this.form)
        .then(res => {
          if (res.code === 200) {
            this.dataArr = res.data.list
            this.total = res.data.total
          }
        })
    },
    handleClick(tab) {
      if (tab.name === 'submit') {
        this.$router.push('/ques/form')
      } else if (tab.name === 'my' || tab.name === 'all') {
        this.getListData()
      }
    },
    handleSizeChange(val) {
      this.form.limit = val
      this.getListData()
    },
    toQuesDetail(id) {
      this.$router.push('/ques/detail?id=' + id)
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getListData()
    }
  }
}
</script>

<style lang="scss" scoped>
.ques-content {
  max-width: 1200px;
  margin: 20px auto;
  background: #fff;
  padding: 0 24px 30px 24px;
  .empty-text {
    text-align: center;
    color: #606266;
    font-size: 14px;
    margin-top: 20px;
  }
  .list-content {
    .data-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 28px;
      font-size: 13px;
      list-style-type: disc;
      padding: 13px 16px 13px 8px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      .title-content {
        display: flex;
        align-items: center;
      }
      .disc-tag {
        color: #3888ff;
        font-size: 40px;
        margin-right: 6px;
      }
      .row-title {
        flex: 1;
        justify-content: start;
        cursor: pointer;
        color: #333;
      }
      .row-date {
        flex-grow: 0;
        color: #606266;
      }
      .status-tag {
        margin-left: 10px;
      }
    }
  }
  .page-content {
    text-align: right;
    margin-top: 10px;
  }
}
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 10px 0;
}
</style>
